export enum PlottingColorByEnum {
  NONE = "none",
  SCHOOL = "school",
  GRADE = "grade",
}

export enum AdvancedFilterOperatorEnum {
  IS = "is",
  IS_NOT = "is_not",
}

export enum PlottingProfileEnum {
  STUDENT = "student",
  SCHOOL = "school",
  DISTRICT = "district",
}

export enum PlottingEthnicityEnum {
  ASIAN = "asian",
  HISPANIC = "hispanic",
  WHITE = "white",
  BLACK = "black",
  OTHER = "other",
}

export enum PlottingSpecialMarkersEnum {
  SDC_MILD = "sdc_mild",
  SDC_MODERATE = "sdc_moderate",
  SDC_SEVERE = "sdc_severe",
  GIFTED = "gifted",
  OTHER = "other",
}

export enum PlottingSchoolTypeEnum {
  ALL = "all",
  K8 = "K8",
  ELEMENTARY = "ELEMENTARY",
  MIDDLE = "MIDDLE",
  HIGH = "HIGH",
  /** UI-only */
  INDIVIDUAL = "individual",
}
